import { createContext, useEffect, useState } from 'react';

import { useContext } from 'react';
import { PAGINATION_KEYS } from '../constants';
import { useGlobal } from './GlobalContext';

const { PAGE, PAGE_SIZE } = PAGINATION_KEYS;

export const defaultFiltersProviderValues = {
  searching: false,
  setSearching: () => null,
  filters: { page: { value: PAGE }, pageSize: { value: PAGE_SIZE } },
  setFilters: () => null,
  handleFilters: () => null,
  handleResetFilters: () => null,
  resetAllFilters: () => null,
  resetFilters: 0,
  displayFilters: false,
  filtersToShow: undefined,
};

const FiltersContext = createContext(defaultFiltersProviderValues);

const FiltersProvider = ({ children }) => {
  const [searching, setSearching] = useState(defaultFiltersProviderValues.searching);
  const [filters, setFilters] = useState(defaultFiltersProviderValues.filters);
  const [resetFilters, setResetFilters] = useState(defaultFiltersProviderValues.resetFilters);
  const [displayFilters, setDisplayFilters] = useState(defaultFiltersProviderValues.displayFilters);
  const [filtersToShow, setFiltersToShow] = useState();
  const { onSearchCount } = useGlobal();

  const handleFilters = (key, value, valueToShow) => {
    setFilters((state) => {
      if (value) {
        return {
          ...state,
          page: { value: PAGE },
          [key]: { value, valueToShow: valueToShow || value },
        };
      } else {
        return {
          ...Object.fromEntries(Object.entries(state).filter((item) => item[0] !== key)),
          page: { value: PAGE },
        };
      }
    });
  };

  const handleResetFilters = () => setResetFilters((state) => state + 1);

  const resetAllFilters = () => {
    setSearching(false);
    setFilters(defaultFiltersProviderValues.filters);
    setResetFilters((state) => state + 1);
    setDisplayFilters(false);
    setFiltersToShow(undefined);
  };

  useEffect(() => {
    setFilters(defaultFiltersProviderValues.filters); // reset filters
  }, [resetFilters]);

  useEffect(() => {
    if (filtersToShow) {
      setDisplayFilters(!!Object.keys(filtersToShow).length);
    } else {
      setDisplayFilters(false);
    }
  }, [filtersToShow]);

  useEffect(() => {
    const { page, pageSize, sort, sortBy, ...rest } = filters;
    if (rest) {
      setFiltersToShow(rest);
    } else {
      setFiltersToShow(undefined);
    }
  }, [filters]);

  useEffect(() => {
    if (onSearchCount === 0) {
      resetAllFilters();
    }
  }, [onSearchCount]);

  const values = {
    searching,
    filters,
    setSearching,
    setFilters,
    handleFilters,
    handleResetFilters,
    resetAllFilters,
    resetFilters,
    displayFilters,
    filtersToShow,
  };

  return <FiltersContext.Provider value={values}>{children}</FiltersContext.Provider>;
};
const useFilters = () => useContext(FiltersContext);

export { FiltersContext, FiltersProvider, useFilters };
